module.exports = __webpack_public_path__ + "static/media/sap-logo.b295ed6f.png";